<script setup>
import FtrMenu from "../components/FtrMenu.vue";

import {DevFittrOSAModel} from "../models";

let deferredPrompt;

import {useRouter} from "vue-router";

const router = useRouter();

const show = localStorage.getItem("show_app_installer");

if (!show) {
  localStorage.setItem("show_app_installer", "true");
}

const beforeInstallPromptHandler = (e) => {
  // Prevents the default mini-infobar or install dialog from appearing on mobile
  e.preventDefault();
  // Save the event because you'll need to trigger it later.
  deferredPrompt = e;
  // Show your customized install prompt for your PWA
  // Your own UI doesn't have to be a single element, you
  // can have buttons in different locations, or wait to prompt
  // as part of a critical journey.
  // console.log(router.options["history"].state.back)
  // if (router.options["history"].state.back) {
  if (localStorage.getItem("show_app_installer") !== "false") {
    showInAppInstallPromotion();
    console.log("install");
  }
  // }
};

async function showInAppInstallPromotion() {
  async function presentAlertConfirm() {
    const alert = await alertController.create({
      header: "U kunt Fittr ook als App installeren!",
      message: "Wilt u deze app installeren?",
      buttons: [
        {
          text: "Nee",
          role: "cancel",
          cssClass: "alert-button-cancel",
          id: "cancel-button",
          handler: (blah) => {
            localStorage.setItem("show_app_installer", "false");
          },
        },
        {
          cssClass: "alert-button-confirm",
          text: "Ja",
          id: "confirm-button",
          handler: async () => {
            //localStorage.setItem('show_app_installer', false);
            if (deferredPrompt) {
              deferredPrompt.prompt();
            }
          },
        },
      ],
    });
    return alert.present();
  }

  await presentAlertConfirm();
}

import {
  IonAvatar,
  IonButtons,
  IonBadge,
  IonCard,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonLabel,
  IonMenuToggle,
  IonPage,
  IonRow,
  IonSegment,
  IonSegmentButton,
  IonSpinner,
  IonToolbar,
  IonButton,
  alertController,
  menuController,
  onIonViewDidEnter,
} from "@ionic/vue";

import {useQuasar, QInnerLoading, QBtn, QBanner} from "quasar";

import {DataStore, SortDirection} from "aws-amplify/datastore";

import {onBeforeUnmount, onMounted, ref} from "vue";
import {useGlobalStore} from "../store/global";
import EventBus from "../Eventbus.js";

const helpContent = ref(`
  <h6>Overzicht Startpagina</h6>

<p>Welkom bij de Fittr-app! Onze applicatie is speciaal ontwikkeld om voet- en schoenspecialisten te ondersteunen bij het vinden van passende leesten en (semi)orthopedische schoenen voor hun cliënten. Hier is hoe u kunt beginnen:</p>

<h6>Doelgroepen</h6>
<p>Onderaan de startpagina vindt u vier categorieën om uit te kiezen: Dames, Heren, Kids, en Safety. Selecteer de groep die het beste aansluit bij de behoeften van uw cliënten om toegang te krijgen tot gespecialiseerde opties.</p>

<h6>Hoofdfuncties</h6>
<p>Na het selecteren van een doelgroep, verschijnen er vier hoofdfunctieknoppen in het midden van het scherm, elk biedt verschillende diensten:</p>
<ul>
    <li><strong>Catalogus (OS A):</strong> Blader door onze collectie schoenontwerpen binnen de OSA-categorie, die volledig op maat gemaakte orthopedische schoenen bevat. Deze optie is ideaal voor cliënten die niet passen in modulaire orthopedische schoenen en maatwerkoplossingen nodig hebben.</li>
    <li><strong>Voetmaten:</strong> Deze functie is speciaal ontworpen voor situaties met nieuwe cliënten. Hier kunt u de maten van zowel de linker- als de rechtervoet invoeren, inclusief de dikte van een aangepaste inlegzool. De applicatie zal een selectie presenteren van de best passende schoenleesten voor deze metingen. Uit deze selectie kunt u de leesten kiezen om overeenkomstige schoenontwerpen te bekijken.</li>
    <li><strong>Leesttypen:</strong> Deze optie is bedoeld voor terugkerende cliënten die al zijn uitgerust met OSB-schoenen. U kunt de bekende maten van eerder verstrekte schoenen invoeren, waarna de applicatie deze metingen gebruikt om de leest van deze schoenen te tonen. Daarnaast biedt de app een selectie van schoenleesten met vergelijkbare pasvormen als mogelijke alternatieven. Uit deze leesten kunnen gebruikers kiezen om overeenkomstige schoenontwerpen te bekijken, vergelijkbaar met het proces in optie 2.</li>
    <li><strong>Catalogus (OS B):</strong> Bekijk een catalogus van OSB-schoenen die niet gebaseerd zijn op specifieke maatselecties.</li>
</ul>

<h6>Menu opties</h6>
<ul>
    <li><strong>Order menu:</strong> Het ordermenu kan geopend worden door op de menuknop te klikken, waarna gebruikers verschillende opties kunnen selecteren die betrekking hebben op orders.
        <ul>
            <li><strong>Orderhistorie:</strong> In het ordermenu kunnen gebruikers de Orderhistorie selecteren, waar een lijst wordt weergegeven met de 20 meest recente orders. Deze lijst biedt een overzicht van elke order, inclusief details zoals het kenmerk, de ingediendatum, locatie, en de status van de order. Gebruikers kunnen specifieke orders bekijken en indien nodig acties ondernemen zoals nabestellen of het invullen van formulieren.</li>
            <li><strong>Zoekfunctie:</strong> Binnen het ordermenu is er een zoekfunctie beschikbaar waar gebruikers eerdere orders kunnen opzoeken door middel van het ordernummer of de klantidentificatie. Dit is bijzonder handig voor het snel terugvinden van specifieke orders.</li>
            <li><strong>Opgeslagen Orders:</strong> Gebruikers hebben ook toegang tot Opgeslagen orders die nog niet zijn ingediend voor verwerking. Dit stelt pedorthisten en podotherapeutische adviseurs in staat om aanpassingen te maken of orders op een later tijdstip te voltooien.</li>
        </ul>
    </li>
    <li><strong>Help:</strong> Het helpmenu biedt toegang tot essentiële hulpmiddelen en informatie voor gebruikers. Het kan worden geopend vanuit het hoofdmenu van de app.
        <ul>
            <li><strong>Versienummer:</strong> In het helpmenu kunnen gebruikers het huidige versienummer van de app vinden. Dit is nuttig voor het identificeren van de softwareversie bij het melden van problemen of voor het verifiëren van updates.</li>
            <li><strong>Herstartknop:</strong> De herstartknop is een belangrijk hulpmiddel voor gebruikers wanneer de app vastloopt of onverwacht gedrag vertoont. Door op deze knop te drukken, wordt de applicatie opnieuw gestart, wat veelvoorkomende problemen kan oplossen zonder de noodzaak voor verdere technische ondersteuning.</li>
        </ul>
    </li>
</ul>
`);

function openTheModal() {
  store.helpContent = helpContent.value;
  // emit the 'openHelp' event
  EventBus.emit("openHelpModal");
}

const store = useGlobalStore();
const $q = useQuasar();
const category = ref();

const osaVisible = ref(false);
const osbVisible = ref(false);
const measurementsVisible = ref(false);
const lastsVisible = ref(false);

const segmentChanged = (ev) => {
  category.value = ev.target.value;
  store.category = ev.target.value;
};

const navigateOSA = async () => {
  // Early returns when conditions aren't met
  if (!store?.logged_in_user) {
    showAlert("Je bent niet ingelogd!");
    return;
  } else if (
      store?.url.includes("careorthopedie")
  ) {
    await router.push(
        "/osa/care-home"
    );
    return
  }
  //else if (
  //    !store?.logged_in_user?.["custom:organisation"].includes("Hanssen")
  //) {
  //  showAlert("Deze functie is momenteel niet beschikbaar!");
  //  return;
  //}
  if (!category.value) {
    showAlert(
        "Om verder te gaan moet er eerst een doelgroep worden geselecteerd!"
    );
    return;
  }

  osaVisible.value = true;

  try {
    // Fetch and filter models
    let temp = [];
    for (let attempt = 0; attempt < 5; attempt++) {
      temp = await DataStore.query(DevFittrOSAModel, (c) => c.and(c => [
        c.category.contains(category.value),
        c.organisation.eq(store.organisational_theme),
      ]), {
        sort: (s) =>
            s
                .modelnumber(SortDirection.ASCENDING)
                .colornumber(SortDirection.ASCENDING),
      });

      if (temp.length > 0) {
        break;
      }
      await new Promise((resolve) => setTimeout(resolve, 400 * (attempt + 1)));
    }

    // Recursively call the function when there are no models
    if (temp.length === 0) {
      showAlert("Er zijn geen modellen gevonden. Probeer het later opnieuw.");
      return;
    }

    let urlModels = [];

    for (let i = 0; i < temp.length; i++) {
      let model = JSON.parse(JSON.stringify(temp[i]));
      model.modelID = model.id;
      urlModels.push(model);
    }

    store.modelCollection = urlModels;

    await router.push({
      path: "/osa/models",
      query: {category: category.value},
    });
  } finally {
    osaVisible.value = false;
  }
};

const navigateDimensions = async () => {
  if (!category.value) {
    showAlert(
        "Om verder te gaan moet er eerst een doelgroep worden geselecteerd!"
    );
    return;
  }
  await router.push(
      "/osb/analyze-footscan/" + category.value
  );
};

const navigateOSB = async () => {
  if (!category.value) {
    showAlert(
        "Om verder te gaan moet er eerst een doelgroep worden geselecteerd!"
    );
    return;
  }

  osbVisible.value = true;

  let temp = [];
  try {
    for (let attempt = 0; attempt < 5; attempt++) {
      temp = await DataStore.query(
          store.Models,
          (c) =>
              c.and((c) => [
                c.category.contains(category.value),
                c[store.organisation].eq(true),
              ]),
          {
            sort: (s) =>
                s
                    .brand(SortDirection.ASCENDING)
                    .modelnumber(SortDirection.ASCENDING)
                    .colornumber(SortDirection.ASCENDING),
          }
      );

      if (temp.length > 0) {
        break;
      }
      await new Promise((resolve) => setTimeout(resolve, 400 * (attempt + 1)));
    }

    //for (let i = 0; i < temp.length; i++) {
    //  let model = JSON.parse(JSON.stringify(temp[i]));
    //  model.modelID = model.id;
    //  model.isVisible = true;
    //  model.price = store.getModelPrice(model);
    //  urlModels.push(model);
    //}

    const combinedMap = {}; // This will hold models keyed by modelnumber-colornumber combination

    for (let i = 0; i < temp.length; i++) {
      const model = JSON.parse(JSON.stringify(temp[i]));
      model.modelID = model.id;
      model.isVisible = true;
      model.price = store.getModelPrice(model);

      const key = `${model.modelnumber}_${model.colornumber}`;

      // If we haven't seen this combination before, store it
      if (!combinedMap[key]) {
        combinedMap[key] = model;
      } else {
        // If we have seen this combination, merge the lasttypes
        // Ensure both are arrays before merging
        if (
            Array.isArray(combinedMap[key].lasttypes) &&
            Array.isArray(model.lasttypes)
        ) {
          const existingLasttypes = combinedMap[key].lasttypes;
          const newLasttypes = model.lasttypes;

          // Merge and remove duplicates using a Set
          const mergedLasttypes = [
            ...new Set([...existingLasttypes, ...newLasttypes]),
          ];
          combinedMap[key].lasttypes = mergedLasttypes;
        }
      }
    }

    // Now convert the map back to an array of combined models
    const urlModels = Object.values(combinedMap);

    // urlModels now contains one combined item per modelnumber-colornumber combination
    // with merged lasttypes arrays

    // if temp is empty, attempt to navigate again.
    if (temp.length === 0) {
      showAlert("Er zijn geen modellen gevonden. Probeer het later opnieuw.");
      return;
    }

    store.modelCollection = urlModels;

    await router.push({
      path: "/osb/models",
      query: {category: category.value},
    });
  } finally {
    osbVisible.value = false;
  }
};

const navigateMeasurements = async () => {
  if (category.value) {
    measurementsVisible.value = true;
    await router.push("/osb/foot-dimensions/" + category.value);
    measurementsVisible.value = false;
  } else {
    showAlert(
        "Om verder te gaan moet er eerst een doelgroep worden geselecteerd!"
    );
  }
};

const navigateLasttypes = async () => {
  if (category.value) {
    lastsVisible.value = true;
    await router.push("/osb/alternative-lasts/" + category.value);
    lastsVisible.value = false;
  } else {
    showAlert(
        "Om verder te gaan moet er eerst een doelgroep worden geselecteerd!"
    );
  }
};

const showAlert = (message) => {
  $q.notify({
    color: "red-5",
    position: "center",
    textColor: "white",
    icon: "fas fa-triangle-exclamation",
    message: message,
  });
};

const openLogin = () => {
  menuController.open();
  store.menuAccordionValue = 'colors'
};

onIonViewDidEnter(async () => {
  store.resetStoreValues();
});

const dismissBanner = ref(true);

const categoryButtons = ref();
const footDimensions = ref();

onMounted(() => {
  window.addEventListener("beforeinstallprompt", beforeInstallPromptHandler);
  setTimeout(function () {
    dismissBanner.value = false;
  }, 1000);
  store.registerGuideRef('categoryButtons', categoryButtons.value.$el);
  store.registerGuideRef('footDimensions', footDimensions.value.$el);
})

onBeforeUnmount(() => {
  window.removeEventListener("beforeinstallprompt", beforeInstallPromptHandler);
});

</script>

<template>

  <ion-page id="help" :class="store.organisational_theme">
    <ion-header class="ion-no-border">
      <ion-toolbar color="none">
        <ion-buttons slot="start">
          <!--          <img class="header-logo" alt="no-image" src="../assets/logo.png" />-->
          <img class="header-logo" alt="no-image" :src="store.app_logo.toString()"/>
        </ion-buttons>
        <ion-buttons slot="end" style="color: var(--ion-color-secondary); margin-right: 10px">
          <ion-button style="color: var(--ion-color-light)" @click="openTheModal">
            <i slot="icon-only" style="font-size: 24px" class="fa-regular fa-question-circle"></i>
          </ion-button>
          <ion-button style="color: var(--ion-color-light)">
            <ion-menu-toggle style="
                z-index: 200;
                position: absolute;
                width: 100px;
                height: 100%;
              "></ion-menu-toggle>
            <i style="font-size: 24px" class="fa-regular fa-bars"></i>
            <ion-badge v-if="!store.logged_in_user && dismissBanner === false" color="secondary" style="
                display: none;
                z-index: 100;
                position: fixed;
                right: 0;
                top: 0;
              " :style="
                !store.logged_in_user ? 'display: block' : 'display: none'
              ">
              <i v-if="!store.logged_in_user && dismissBanner === false" class="fa-regular fa-user-xmark"></i>
            </ion-badge>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <q-banner v-if="!store.logged_in_user && dismissBanner === false" inline-actions class="bg-red text-white" style="
    z-index: 10000;position: absolute;top:90px;width: 50%;left:25%">
      Je bent niet ingelogd, niet alle functies zijn beschikbaar!
      <template v-slot:action>
        <q-btn @click="openLogin" flat label="Login"/>
      </template>
    </q-banner>


    <ion-content class="background-image">
      <div slot="fixed" class="homepage-overlay">
        <ion-grid style="margin-top: 30px">
          <ion-row style="flex-wrap: wrap-reverse; align-content: flex-start">

            <ion-col size-xs="6" size-sm="6" size-md="3" size-lg="3" size-xl="3">
              <ion-card ref="exampleElement2" button @click="navigateOSA()">
                <div class="card-overlay-osa"></div>

                <ion-avatar>
                  <img alt="no image" src="../assets/img/osa_catalogue.png"/>
                </ion-avatar>

                <ion-card-header>
                  <ion-card-subtitle style="border-bottom: 1px rgba(175, 175, 183, 1) solid">OS<span class="os-type"> A</span>
                  </ion-card-subtitle>
                  <ion-card-title>Catalogus</ion-card-title>
                </ion-card-header>

                <q-inner-loading :showing="osaVisible">
                  <ion-spinner></ion-spinner>
                </q-inner-loading>
              </ion-card>
            </ion-col>

            <ion-col ref="footDimensions" size-xs="6" size-sm="6" size-md="3" size-lg="3" size-xl="3">
              <ion-card style="--background: var(--ion-color-secondary)" button @click="navigateMeasurements()">
                <div class="card-overlay"></div>
                <ion-avatar style="background:white">
                  <img alt="no image" src="../assets/img/manual_measure_icon.png"/>
                </ion-avatar>
                <ion-card-header>
                  <ion-card-subtitle style="border-bottom: 1px rgba(175, 175, 183, 1) solid">OS<span class="os-type"> B</span>
                  </ion-card-subtitle>
                  <ion-card-title>Voetmaten</ion-card-title>
                </ion-card-header>

                <q-inner-loading :showing="measurementsVisible">
                  <ion-spinner></ion-spinner>
                </q-inner-loading>
              </ion-card>
            </ion-col>

            <ion-col size-xs="6" size-sm="6" size-md="3" size-lg="3" size-xl="3">
              <ion-card style="--background: var(--ion-color-secondary)" button @click="navigateDimensions()">
                <div class="card-overlay"></div>
                <img style="position:absolute;top: 0;right:0" alt="no image" src="../assets/img/beta_icon.png"/>
                <ion-avatar>
                  <img alt="no image" src="../assets/img/3d_scan.png"/>
                </ion-avatar>
                <ion-card-header>
                  <ion-card-subtitle style="border-bottom: 1px rgba(175, 175, 183, 1) solid">OS<span class="os-type"> B</span>
                  </ion-card-subtitle>
                  <ion-card-title>3D Scan</ion-card-title>
                </ion-card-header>

                <q-inner-loading :showing="measurementsVisible">
                  <ion-spinner></ion-spinner>
                </q-inner-loading>
              </ion-card>
            </ion-col>

            <ion-col size-xs="6" size-sm="6" size-md="3" size-lg="3" size-xl="3">
              <ion-card style="--background: var(--ion-color-secondary)" button @click="navigateLasttypes()">
                <div class="card-overlay"></div>
                <ion-avatar>
                  <img alt="no image" src="../assets/img/last.jpg"/>
                </ion-avatar>
                <ion-card-header>
                  <ion-card-subtitle style="border-bottom: 1px rgba(175, 175, 183, 1) solid">OS<span class="os-type"> B</span>
                  </ion-card-subtitle>
                  <ion-card-title>Leesttypen</ion-card-title>
                </ion-card-header>

                <q-inner-loading :showing="lastsVisible">
                  <ion-spinner></ion-spinner>
                </q-inner-loading>
              </ion-card>
            </ion-col>

            <ion-col size-xs="6" size-sm="6" size-md="3" size-lg="3" size-xl="3" @click="navigateOSB()">
              <ion-card style="--background: var(--ion-color-secondary); z-index: 0" button>
                <div class="card-overlay"></div>
                <ion-avatar>
                  <img alt="no image" src="../assets/img/catalogue.jpg"/>
                </ion-avatar>
                <ion-card-header>
                  <ion-card-subtitle style="border-bottom: 1px rgba(175, 175, 183, 1) solid">OS<span class="os-type"> B</span>
                  </ion-card-subtitle>
                  <ion-card-title>Catalogus</ion-card-title>
                </ion-card-header>

                <q-inner-loading :showing="osbVisible">
                  <ion-spinner></ion-spinner>
                </q-inner-loading>
              </ion-card>
            </ion-col>

<!--            <ion-col size-xs="6" size-sm="6" size-md="3" size-lg="3" size-xl="3" @click="navigateOSB()">-->
<!--              <ion-card style="&#45;&#45;background: var(&#45;&#45;ion-color-tertiary-tint); z-index: 0" button>-->
<!--                <div class="card-overlay"></div>-->
<!--                <ion-avatar>-->
<!--                  <img alt="no image" src="../assets/img/guide4.png"/>-->
<!--                </ion-avatar>-->
<!--                <ion-card-header>-->
<!--                  <ion-card-subtitle style="border-bottom: 1px rgba(175, 175, 183, 1) solid">-->
<!--                    <span style="visibility: hidden;" class="os-type">X</span>-->
<!--                  </ion-card-subtitle>-->
<!--                  <ion-card-title>Hulp & Uitleg</ion-card-title>-->
<!--                </ion-card-header>-->

<!--                <q-inner-loading :showing="osbVisible">-->
<!--                  <ion-spinner></ion-spinner>-->
<!--                </q-inner-loading>-->
<!--              </ion-card>-->
<!--            </ion-col>-->

          </ion-row>
        </ion-grid>
      </div>
    </ion-content>

    <ion-footer>
      <ion-toolbar style="display: flex; align-items: center" color="null">
        <ion-segment ref="categoryButtons" v-model="category" @click="segmentChanged" color="secondary">
          <ion-segment-button value="f" style="width: 100%">
            <i class="fa-thin fa-female footer-icon"></i>
            <ion-label style="margin-top: 0; margin-bottom: 0">Dames
            </ion-label>
          </ion-segment-button>
          <ion-segment-button value="m" style="width: 100%">
            <i class="fa-thin fa-male footer-icon"></i>
            <ion-label style="margin-top: 0; margin-bottom: 0">Heren
            </ion-label>
          </ion-segment-button>
          <ion-segment-button value="k" style="width: 100%">
            <i class="fa-thin fa-child footer-icon"></i>
            <ion-label style="margin-top: 0; margin-bottom: 0">Kids</ion-label>
          </ion-segment-button>
          <ion-segment-button value="w" style="width: 100%">
            <i class="fa-thin fa-user-helmet-safety footer-icon"></i>
            <ion-label style="margin-top: 0; margin-bottom: 0">Safety
            </ion-label>
          </ion-segment-button>
        </ion-segment>
      </ion-toolbar>
    </ion-footer>
    <FtrMenu></FtrMenu>
  </ion-page>
</template>

<style>
button.alert-button.alert-button-cancel {
  background-color: var(--ion-color-danger);
  color: var(--ion-color-light);
}

button.alert-button.alert-button-confirm {
  background-color: var(--ion-color-warning);
  color: var(--ion-color-light);
}

.q-banner {
  min-height: 30px !important;
  padding: 0 16px !important;
}

.q-banner__content {
  font-size: 16px !important;
  text-align: center;
}
</style>

<style scoped>
/*FOOTCARE*/
.footcare {
  ion-footer {
    background: var(--ion-color-primary);
  }

  ion-segment i {
    color: var(--ion-color-secondary);
  }

  ion-label {
    color: var(--ion-color-secondary);
  }

  .homepage-overlay {
    height: 100vh;
    width: 100%;
    top: 0;
    left: 0;
    padding-left: 5px;
    padding-right: 5px;
    position: absolute;
    background: rgba(255, 255, 255, 0.4);
  }

  .card-overlay-osa {
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    position: absolute;
    /*background: var(--ion-color-primary);
    opacity: 0.9;*/
    /* background: rgba(75, 75, 93, 0.5);*/
    background: rgba(125, 125, 123, 0.5);
  }

  .card-overlay {
    background: rgba(75, 75, 93, 0.5);
  }

  ion-card {
    --background: var(--ion-color-secondary);
  }

  .header-logo {
    height: 100px;
    margin: 10px 5px 0 16px;
  }

}


/*CARE ORTHOPEDIE*/
.care {
  ion-footer {
    background: var(--ion-color-secondary);
  }

  ion-segment i {
    color: var(--ion-color-primary);
  }

  ion-label {
    color: var(--ion-color-primary);
  }

  .homepage-overlay {
    height: 100vh;
    width: 100%;
    top: 0;
    left: 0;
    padding-left: 5px;
    padding-right: 5px;
    position: absolute;
    background: rgba(237, 235, 221, 0.2);
  }

  .card-overlay-osa {
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    position: absolute;
    /*background: var(--ion-color-primary);
    opacity: 0.9;*/
    /* background: rgba(75, 75, 93, 0.5);*/
    background: rgba(26, 46, 67, 0.8);
  }

  .card-overlay {
    background: rgba(26, 46, 67, 1);
  }

  ion-card {
    --background: var(--ion-color-secondary);
  }

  .header-logo {
    height: 80px;
    margin: 10px 5px 0 16px;
  }
}

/*VOETMAX*/
.voetmax {
  ion-footer {
    background-color: var(--ion-color-tertiary);
  }

  ion-segment i {
    color: var(--ion-color-light);
  }

  ion-label {
    color: var(--ion-color-light);
  }

  .homepage-overlay {
    /*background: var(--ion-color-primary), opacity(0.15);*/
    background: hsla(0, 0%, 84.3%, 0.5);
  }

  .card-overlay-osa {
    background: rgba(125, 125, 125, 0.4);
  }

  .card-overlay {
    background: rgba(75, 75, 75, 0.4);
  }

  ion-card {
    --background: var(--ion-color-secondary);
  }

  .header-logo {
    height: 70px;
    margin: 10px 5px 0 16px;
  }
}


/*FITTR*/
.fittr {
  ion-footer {
    background-color: var(--ion-color-light);
  }

  ion-segment i {
    color: var(--ion-color-primary);
  }

  ion-label {
    color: var(--ion-color-primary);
  }

  .homepage-overlay {
    background: rgba(75, 75, 93, 0.2);
  }

  .card-overlay-osa {
    background: var(--ion-color-primary);
    opacity: 0.8;
  }

  .card-overlay {
    background: rgba(75, 75, 93, 0.5);
  }

  ion-card {
    --background: var(--ion-color-secondary);
  }

  .header-logo {
    height: 80px;
    margin: 10px 5px 0 16px;
  }
}


/*GENERAL STYLES*/

ion-col {
  padding: 0 5px;
}


ion-card {
  --padding-inline-start: 5px;
  --padding-top: 5px;
  border-radius: 20%;
  aspect-ratio: 1 / 1;
  box-shadow: 0px 6px 18px rgba(0, 0, 0, 0.25); /* soft drop shadow */
}

.homepage-overlay {
  height: 100vh;
  width: 100%;
  top: 0;
  left: 0;
  padding-left: 5px;
  padding-right: 5px;
  position: absolute;
}

.card-overlay-osa {
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  position: absolute;
}

ion-avatar {
  position: absolute;
  top: 16px;
  left: 16px;
  width: 70px;
  height: 70px;
}


ion-card-header {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  flex-direction: column;
}

@media (min-width: 350px) {
  ion-grid {
    height: 100%;
    width: 100%;
  }

  ion-row {
    width: 100%;
    height: 100%;
    padding-bottom: calc(150px + var(--ion-safe-area-bottom));
    align-content: flex-end;
  }

  .os-type {
    color: rgba(255, 255, 255, 0.75);
    font-size: 1.4rem;
  }

  ion-content {
    --background: rgba(75, 75, 93, 0.7);
  }

  .background-image {
    position: absolute;
    height: 100vh;
    width: 100%;
    background-image: url(../assets/img/homepage.jpg);
    background-position: top;
    background-size: cover;
    top: 0;
    left: 0;
    background-repeat: no-repeat;
  }

  .card-overlay {
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    position: absolute;
  }

  ion-segment {
    width: 90%;
    margin-bottom: 10px;
    margin-top: 10px;
  }

  .md ion-segment {
    left: 5%;
  }

  ion-segment-button {
    padding-top: 5px;
    width: 70px;
  }

  .segment-button-indicator {
    opacity: 0.5;
  }

  .footer-icon {
    font-size: 1.5em;
    font-weight: bold;
  }

  ion-col {
    padding: 0 10px;
  }


  ion-avatar {
    width: 60px;
    height: 60px;
  }

  ion-card {

  }

  ion-card-header {
    padding: 16px;
  }

  ion-card-subtitle {
    margin: 0 0 8px 0;
    border-bottom: 1px rgba(75, 75, 83, 1) solid;
    color: rgba(255, 255, 255, 0.5);
    padding-bottom: 0;
    font-size: 0.7rem;
    text-align: left;
  }

  ion-card-title {

    color: rgba(255, 255, 255, 0.9);
    font-size: 1rem;
    text-align: center;
  }

  ion-toolbar {
    background-image: none !important;
  }
}


@media (min-width: 410px) {

  .os-type {
    color: rgba(255, 255, 255, 0.75);
    font-size: 1.4rem;
  }

  .footer-icon {
    font-size: 1.5em;
    font-weight: bold;
  }

  ion-col {
    padding: 0 0;
  }

  ion-avatar {
    width: 60px;
    height: 60px;
  }

  ion-card {

  }

  ion-card-header {
    padding: 16px;
  }

  ion-card-subtitle {
    margin: 0 0 8px 0;
    border-bottom: 1px rgba(75, 75, 83, 1) solid;
    color: rgba(255, 255, 255, 0.5);
    padding-bottom: 0;
    font-size: 0.7rem;
    text-align: left;
  }

  ion-card-title {

    color: rgba(255, 255, 255, 0.9);
    font-size: 1rem;
    text-align: center;
  }

}

/*###############################################################*/
@media (min-width: 576px) {
  ion-row {
    padding-bottom: calc(130px + var(--ion-safe-area-bottom));
  }

  ion-card {

  }

  .homepage-overlay {
    padding-left: 20px;
    padding-right: 20px;
  }

  ion-card-subtitle {
    margin: 0 0 8px 0;
    border-bottom: 1px rgba(75, 75, 83, 1) solid;
    color: rgba(255, 255, 255, 0.5);
    padding-bottom: 5px;
    font-size: 1.3rem;
    text-align: left;
  }

  ion-card-title {
    color: rgba(255, 255, 255, 0.9);
    font-size: 1.4rem;
    text-align: center;
  }

  ion-segment {
    width: 60%;
    margin-bottom: 10px;
    margin-top: 10px;
  }

  .md ion-segment {
    left: 20%;
  }
}

/*###############################################################*/
@media (min-width: 768px) {
  ion-card-subtitle {
    margin: 0 0 16px 0;
    border-bottom: 1px rgba(75, 75, 83, 1) solid;
    color: rgba(255, 255, 255, 0.5);
    padding-bottom: 5px;
    font-size: 1.3rem;
    text-align: right;
  }

  ion-card-title {
    margin: 0 0 0 0;
    color: rgba(255, 255, 255, 0.9);
    font-size: 1.4rem;
    text-align: center;
  }

  /*.header-logo {
    height: 50px;
    margin: 10px 10px 10px 16px;
  }*/
  ion-row {
    padding-bottom: calc(130px + var(--ion-safe-area-bottom));
  }

  ion-card {

  }

  ion-segment-button {
    width: 100px;
  }

  ion-col {
    padding: 0 0;
  }
}

/*###############################################################*/
@media (min-width: 992px) {
  ion-segment-button {
    width: 125px;
  }
}

/*###############################################################*/
@media (min-width: 1024px) {
  ion-card-subtitle {
    margin: 0 0 8px 0;
    border-bottom: 1px rgba(75, 75, 83, 1) solid;
    color: rgba(255, 255, 255, 0.5);
    padding-bottom: 5px;
    font-size: 1.3rem;
    text-align: right;
  }

  ion-card-title {
    margin: 0 0 0 0;
    color: rgba(255, 255, 255, 0.9);
    font-size: 1.4rem;
    text-align: center;
  }

  ion-avatar {
    width: 70px;
    height: 70px;
  }

  ion-card {

  }

  ion-row {
    padding-bottom: calc(140px + var(--ion-safe-area-bottom));
  }

  ion-col {
    padding: 0 20px;
  }
}

/*###############################################################*/
@media (min-width: 1150px) {

  ion-card {
    margin: 15px 15px;
    padding: 0 4px;
  }

  ion-card-subtitle {
    margin: 0 0 8px 0;
    border-bottom: 1px rgba(75, 75, 83, 1) solid;
    color: rgba(255, 255, 255, 0.5);
    padding-bottom: 5px;
    font-size: 1.3rem;
    text-align: right;
  }

  ion-card-title {
    margin: 0 0 0 0;
    color: rgba(255, 255, 255, 0.9);
    font-size: 1.4rem;
    text-align: center;
  }

  ion-col {
    padding: 20px 45px;
  }

  ion-avatar {
    width: 70px;
    height: 70px;
  }

}

@media (min-width: 1300px) {
  ion-avatar {
    width: 70px;
    height: 70px;
  }

  ion-card {
    margin: 10px 40px;
  }

  ion-row {
    padding-bottom: calc(130px + var(--ion-safe-area-bottom));
  }

  ion-col {
    padding: 15px 50px;
  }
}

@media (min-width: 1900px) {
  ion-card-subtitle {
    margin: 0 0 16px 0;
    border-bottom: 1px rgba(75, 75, 83, 1) solid;
    color: rgba(255, 255, 255, 0.5);
    padding-bottom: 5px;
    font-size: 1.7rem;
    text-align: right;
  }

  ion-card-title {
    margin: 0 0 0 0;
    color: rgba(255, 255, 255, 0.9);
    font-size: 1.8rem;
    text-align: center;
  }

  ion-avatar {
    width: 110px;
    height: 110px;
  }

  ion-card {
    margin: 45px 45px;
    padding: 8px;
  }

  ion-row {
    padding-bottom: calc(150px + var(--ion-safe-area-bottom));
  }

  ion-col {
    padding: 0 60px;
  }
}

@media (min-width: 2550px) {
  ion-card-subtitle {
    margin: 0 0 16px 0;
    border-bottom: 1px rgba(75, 75, 83, 1) solid;
    color: rgba(255, 255, 255, 0.5);
    padding-bottom: 5px;
    font-size: 1.7rem;
    text-align: right;
  }

  ion-card-title {
    margin: 0 0 0 0;
    color: rgba(255, 255, 255, 0.9);
    font-size: 1.8rem;
    text-align: center;
  }

  ion-avatar {
    width: 110px;
    height: 110px;
  }

  ion-card {
    margin: 65px 65px;
    padding: 16px;
  }

  ion-row {
    padding-bottom: calc(150px + var(--ion-safe-area-bottom));
  }

  ion-col {
    padding: 0 80px;
  }
}

@media (min-width: 3800px) {
  ion-card-subtitle {
    margin: 0 0 16px 0;
    border-bottom: 1px rgba(75, 75, 83, 1) solid;
    color: rgba(255, 255, 255, 0.5);
    padding-bottom: 5px;
    font-size: 2.1rem;
    text-align: right;
  }

  ion-card-title {
    margin: 0 0 0 0;
    color: rgba(255, 255, 255, 0.9);
    font-size: 2.2rem;
    text-align: center;
  }

  ion-avatar {
    width: 110px;
    height: 110px;
  }

  ion-card {
    margin: 105px 105px;
    padding: 24px;
  }

  ion-row {
    padding-bottom: calc(170px + var(--ion-safe-area-bottom));
  }

  ion-col {
    padding: 0 100px;
  }
}
</style>
